import {
  styled,
  Grid,
  TableCell,
  Button,
  tableCellClasses,
  Typography,
  Paper,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText
} from '@mui/material';
import React, { useState } from 'react';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import PageHeader from '../../../../components/PageHeader';
import { api } from '../../../../api';
import { Link, useNavigate } from 'react-router-dom';
import { Form } from '../../SystemManagement';
import CompanyFromInput from '../../../../components/formInput/CompanyFromInput';
import UserRoleFromInput from '../../../../components/formInput/UserRoleFromInput';

const UserCreate: React.FC = () => {
  const navigate = useNavigate();

  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [rePassword, setRePassword] = useState<string>('');
  const [firstName, setFirstName] = useState<string>('');
  const [lastName, setLastName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [phoneNumber, setPhoneNumber] = useState<string>('');

  const [companyId, setCompanyId] = useState<number | null>(null);
  const [roleId, setRoleId] = useState<number | null>(null);

  const [formError, setFormError] = useState<Record<string, string>>({});

  const [isOpenSuccessDialog, setIsOpenSuccessDialog] = useState<boolean>(false);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const openSuccessDialog = () => {
    setIsOpenSuccessDialog(true);
    setTimeout(() => {
      setIsOpenSuccessDialog(false);
      navigate('/user');
    }, 1000);
  };
  const validateInput = () => {
    const fErr: Record<string, string> = {};

    if (email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      fErr['email'] = 'Invalid email address';
    }

    if (!/[0-9]+/g.test(password)) {
      fErr['password'] = 'Require that at least one digit';
    } else if (!/[a-z]+/g.test(password)) {
      fErr['password'] = 'Require that at least one lowercase letter';
    } else if (!/[A-Z]+/g.test(password)) {
      fErr['password'] = 'Require that at least one uppercase letter';
    } else if (!/[*.!@$%^&(){}[\]:;<>,.?/~_+\-=|\\]+/g.test(password)) {
      fErr['password'] = 'Require that at least one special character';
    } else if (!/.{8,32}/g.test(password)) {
      fErr['password'] = 'At least 8 characters in length, but no more than 32';
    } else if (password !== rePassword) {
      fErr['password'] = 'password != re-password';
      fErr['rePassword'] = 'password != re-password';
    }

    if (Object.keys(fErr).length !== 0) {
      setFormError(fErr);
      return false;
    }
    setFormError({});
    return true;
  };
  const handleFormSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (!validateInput()) {
      return;
    }
    save();
  };

  const save = () => {
    if (!validateInput()) {
      return;
    }
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    api
      .post(`/user`, {
        user_name: username,
        password: password,
        first_name: firstName,
        last_name: lastName,
        email: email ? email : undefined,
        phone_number: phoneNumber,
        role_id: roleId,
        company_id: companyId
      })
      .then(() => {
        openSuccessDialog();
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <Container>
      <PageHeader text="เพิ่มข้อมูล User" />
      <Button component={Link} to={`/user`} sx={{ my: 3, p: 0 }}>
        <ArrowBackIosIcon />
        User
      </Button>

      <Paper sx={{ p: 3 }}>
        <Typography variant="h6">{'ข้อมูล User'}</Typography>
        <Form onSubmit={handleFormSubmit} sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Username"
                variant="outlined"
                placeholder="Username"
                value={username ? username : ''}
                onChange={(e) => setUsername(e.target.value ? e.target.value : '')}
                required
              />
            </Grid>
            <Grid item xs={6}>
              <UserRoleFromInput value={roleId} onChange={(id) => setRoleId(id)} required />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                type={'password'}
                label="Password"
                variant="outlined"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value ? e.target.value : '')}
                required
                error={!!formError['password']}
                helperText={formError['password']}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                type={'password'}
                label="Re-Password"
                variant="outlined"
                placeholder="Re-Password"
                value={rePassword}
                onChange={(e) => setRePassword(e.target.value ? e.target.value : '')}
                required
                error={!!formError['rePassword']}
                helperText={formError['rePassword']}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={3}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="ชื่อ"
                variant="outlined"
                placeholder="ชื่อ"
                onChange={(e) => setFirstName(e.target.value ? e.target.value : '')}
                value={firstName}
                required
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="นามสกุล"
                variant="outlined"
                placeholder="นามสกุล"
                onChange={(e) => setLastName(e.target.value ? e.target.value : '')}
                value={lastName}
                required
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="อีเมล"
                variant="outlined"
                placeholder="อีเมล"
                onChange={(e) => setEmail(e.target.value ? e.target.value : '')}
                value={email}
                error={!!formError['email']}
                helperText={formError['email']}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                type="tel"
                label="เบอร์โทรศัพท์"
                variant="outlined"
                placeholder="เบอร์โทรศัพท์"
                onChange={(e) => setPhoneNumber(e.target.value ? e.target.value : '')}
                value={phoneNumber}
                required
              />
            </Grid>
            <Grid item xs={6}>
              <CompanyFromInput value={companyId} onChange={(id) => setCompanyId(id)} required />
            </Grid>
            <Grid container columns={2} spacing={2} sx={{ mt: 0 }} direction={'row-reverse'}>
              <Grid item>
                <Button type="submit" variant="contained" color="primary">
                  เพิ่ม
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Form>
      </Paper>
      <Dialog open={isOpenSuccessDialog} onClose={() => setIsOpenSuccessDialog(false)}>
        <DialogTitle>{'Success'}</DialogTitle>
        <DialogContent>
          <DialogContentText>ดำเนินการสำเร็จ</DialogContentText>
        </DialogContent>
      </Dialog>
    </Container>
  );
};

export default UserCreate;

const Container = styled('div')`
  padding: 24px;
`;
